import { createAction, handleActions } from 'redux-actions'

// 타입 정의
export const SET_MARKET = 'SET_MARKET';
export const SELECT_MARKET = 'SELECT_MARKET';
export const SET_TICKER = 'SET_TICKER';
export const SET_TICKER_CH24HOUR = 'SET_TICKER_CH24HOUR';
export const SET_ORDERPRICE_FROM_ORDERBOOK = 'SET_ORDERPRICE_FROM_ORDERBOOK';
export const SET_ORDERBOOK = 'SET_ORDERBOOK';
export const SET_ORDERBOOK_INIT = 'SET_ORDERBOOK_INIT';
export const SET_TRADE_HISTORY = 'SET_TRADE_HISTORY';
export const SET_RELOAD = 'SET_RELOAD';
export const SET_RELOAD_COMPLETE = 'SET_RELOAD_COMPLETE';
export const SET_TOTAL_VOLUME = 'SET_TOTAL_VOLUME';

// 액션 내보내기
export const setMarketList = createAction(
    SET_MARKET,
    (marketList) => (marketList)
)
export const selectMarket = createAction(
    SELECT_MARKET,
    (nowMarket) => (nowMarket)
)
export const setTicker = createAction(
    SET_TICKER,
    (data) => (data)
)
export const setTickerCh24Hour = createAction(
    SET_TICKER_CH24HOUR,
    (data) => (data)
)
export const setOrderPriceFromOrderbook = createAction(
    SET_ORDERPRICE_FROM_ORDERBOOK,
    (data) => (data)
)
export const setOrderbook = createAction(
    SET_ORDERBOOK,
    (data) => (data)
)
export const setOrderbookInit = createAction(
    SET_ORDERBOOK_INIT
)
export const setTradeHistory = createAction(
    SET_TRADE_HISTORY,
    (data) => (data)
)
export const setReload = createAction(
    SET_RELOAD
)
export const setReloadComplete = createAction(
    SET_RELOAD_COMPLETE
)
export const setTotalVolume = createAction(
    SET_TOTAL_VOLUME,
    (data) => (data)
)

// 초기 상태값
const initialState = {
    needToReload:false,
    selectedMarket:{
        name: '',
        pair: '',
        baseSymbol: '',
        baseDecimal: 0,
        last: 0,
        high: 0,
        low: 0,
        volume24h: 0,
    },
    orderPriceFromOrderbook: null,
    marketList: {},
    ticker: {},
    ch24hour: {},
    orderbook: {
        buy:[],
        sell:[]
    },
    tradeHistory:[],
    totalVolume:0
}

// 리듀서 내보내기
export default handleActions({
    [SET_MARKET]: (state, { payload }) => {
        if(typeof payload !== "undefined"){
            return {
                ...state,
                marketList: Object.assign({}, ...payload.map((n)=>({
                    [n.pair]:{
                        ...n
                    }
                })))
            }
        }else{
            return state
        }
    },
    [SELECT_MARKET]: (state, { payload }) => {
        return {
            ...state,
            selectedMarket: payload
        }
    },
    [SET_TICKER]: (state, { payload }) => {
        return {
            ...state,
            ticker: payload
        }
    },
    [SET_TICKER_CH24HOUR]: (state, { payload }) => {
        return {
            ...state,
            ch24hour: payload
        }
    },
    [SET_ORDERPRICE_FROM_ORDERBOOK]: (state, { payload }) => {
        return {
            ...state,
            orderPriceFromOrderbook: payload
        }
    },
    [SET_ORDERBOOK]: (state, { payload }) => {
        return {
            ...state,
            orderbook: {
                buy:payload.buy,
                sell:payload.sell
            }
        }
    },
    [SET_ORDERBOOK_INIT]: (state) => {
        return {
            ...state,
            orderbook: {
                buy:[],
                sell:[]
            },
            tradeHistory:[]
        }
    },
    [SET_TRADE_HISTORY]: (state, { payload }) => {
        return {
            ...state,
            tradeHistory: payload
        }
    },
    [SET_RELOAD]: (state) => {
        return {
            ...state,
            needToReload:true
        }
    },
    [SET_RELOAD_COMPLETE]: (state) => {
        return {
            ...state,
            needToReload:false
        }
    },
    [SET_TOTAL_VOLUME]: (state, { payload }) => {
        return {
            ...state,
            totalVolume: payload
        }
    }
}, initialState);
